import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addRuleJurisdiction } from 'api/wage/addRuleJurisdiction'
import { wageRuleKeys } from './keys'

export const useAddRuleJurisdictionMutation = (ruleId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof addRuleJurisdiction>[0]) =>
      addRuleJurisdiction(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: wageRuleKeys.byId(ruleId),
      })
    },
  })
}
